module.exports = __webpack_public_path__ + "static/media/majorB2.6617d31.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/sing/majorB2.wav
// module id = CSmY
// module chunks = 0